import { Component, OnChanges, SimpleChanges, Input } from '@angular/core';
import { Disclaimer } from './disclaimers.interface.disclaimer';
import { DisclaimerSettings } from './disclaimers.interface.settings';
import { CcssService } from '@services/ccss/ccss.service';
import { includes } from 'lodash';

@Component({
  selector: 'app-disclaimers',
  templateUrl: './disclaimers.component.html',
  styleUrls: ['./disclaimers.component.scss'],
})
export class DisclaimersComponent implements OnChanges {
  @Input() public disclaimers: Disclaimer[] = [];
  @Input() public settings: DisclaimerSettings = new DisclaimerSettings({});
  @Input() public alwaysShowIcons: boolean;
  @Input() public clamp: boolean = true;
  @Input() public container: boolean = false;

  // Map disclaimer level to banner status
  public levels: any = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    '1': 'error',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    '2': 'warn',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    '3': 'info',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    '4': 'success',
  };

  constructor(public ccss: CcssService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.disclaimers) {
      this.setDisclaimersValue(changes.disclaimers.currentValue);
    }

    if (changes.settings && this.disclaimers) {
      this.setSettingsValue(changes.settings.currentValue);
    }
  }

  public trackByFn(index: number, item: Disclaimer): string {
    return `${item.id}${item.label}${item.text}${item.level}`;
  }

  private setDisclaimersValue(disclaimers: Disclaimer[]): void {
    if (disclaimers) {
      this.disclaimers = disclaimers.map(
        (disclaimer) => new Disclaimer(disclaimer)
      );
      this.mapDisclaimers();
    }
  }

  private setSettingsValue(settings: DisclaimerSettings): void {
    this.settings = new DisclaimerSettings(settings);
    this.mapDisclaimers();
  }

  private mapDisclaimers() {
    this.disclaimers = this.disclaimers.reduce(
      (mapped: Disclaimer[], disclaimer: Disclaimer) => {
        if (disclaimer.text.length && disclaimer.text.length > 3) {
          if (
            this.settings.suppress_disclaimers.length &&
            !includes(this.settings.suppress_disclaimers, disclaimer.id)
          ) {
            mapped.push(disclaimer);
          } else if (!this.settings.suppress_disclaimers.length) {
            mapped.push(disclaimer);
          }
        }
        return mapped;
      },
      []
    );
  }
}
